import React from "react";
import {LexicalComposer} from "@lexical/react/LexicalComposer";
import {RichTextPlugin} from "@lexical/react/LexicalRichTextPlugin";
import {ContentEditable} from "@lexical/react/LexicalContentEditable";
import {HistoryPlugin} from "@lexical/react/LexicalHistoryPlugin";
import {ListPlugin} from "@lexical/react/LexicalListPlugin";
import {LexicalErrorBoundary} from "@lexical/react/LexicalErrorBoundary";
import {ListNode, ListItemNode} from "@lexical/list";

import {HtmlSyncPlugin} from "./HtmlSyncPlugin";
import {ReadOnlySyncPlugin} from "./ReadOnlySyncPlugin";
import {RichTextToolbarPlugin} from "./Toolbar/RichTextToolbarPlugin";

const theme = {
    text: {
        bold: 'lexical-text-bold',
    },
};

const onError = (error) => console.error(error);

// Registered unconditionally (even on toolbar-less editors) so pasted or pre-existing
// <ul>/<li> markup round-trips through $generateNodesFromDOM instead of being dropped.
const nodes = [ListNode, ListItemNode];

/**
 * Lexical-based rich text editor with a plain-HTML-string value/onChange contract,
 * matching the previous ReactQuill-based components it replaces.
 *
 * @param namespace Unique identifier for this editor instance
 * @param value Current content as an HTML string
 * @param onChange Called with the new HTML string whenever the user edits the content
 * @param readOnly Whether the editor is editable, can change after mount
 * @param showToolbar Whether to render a toolbar
 */
const LexicalRichTextEditor = ({namespace, value, onChange, readOnly = false, showToolbar = false}) =>
{
    const initialConfig = {
        namespace,
        theme,
        onError,
        editable: !readOnly,
        nodes,
    };

    return (
        <LexicalComposer initialConfig={initialConfig}>
            <div className="lexical-editor-shell">
                {showToolbar && <RichTextToolbarPlugin/>}
                <RichTextPlugin
                    contentEditable={<ContentEditable className="lexical-content-editable"/>}
                    placeholder={null}
                    ErrorBoundary={LexicalErrorBoundary}
                />
                <HistoryPlugin/>
                <ListPlugin/>
                <HtmlSyncPlugin value={value} onChange={onChange}/>
                <ReadOnlySyncPlugin readOnly={readOnly}/>
            </div>
        </LexicalComposer>
    );
}

export {LexicalRichTextEditor};
